import { message } from 'antd'
import React, { useState } from 'react'

import Modal from '../reusable/modal'

const Settings = ({ toggle, visible }) => {
    const [station, setStation] = useState(localStorage.getItem('station'))

    const modify = e => {
        switch (e.target.name) {
            case 'station':
                setStation(e.target.value)
                break

            default:
                break
        }
    }

    const onSave = () => {
        localStorage.setItem('station', station)

        message.success('Settings have been saved')

        setTimeout(toggle, 300)
    }

    return (
        <Modal
            width={ 500 }
            title="Settings"
            visible={ visible }
            onCancel={ toggle }>
            <div className="flex flex-wrap mt-0">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Station
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-black border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="station"
                        name="station"
                        value={ station }
                        onChange={ modify }
                        type="text"
                        placeholder="X-Ray" />
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={ onSave } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
            </div>
        </Modal>
    )
}

export default Settings
